/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */
import 'core-js/stable';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';


import './styles/css/style.css';

import { I18nextProvider } from 'react-i18next';
import i18n from './config/i18n';

import App from './App';
import * as serviceWorker from './serviceWorker';
import 'moment-timezone';

var doctitle = window.location.href;
var parts = doctitle.split('/');
document.title = parts[2];


const routing = (
    <I18nextProvider i18n={i18n}>
        <App />
    </I18nextProvider>
)
ReactDOM.render(routing, document.getElementById('root'))


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
